module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "homefooter"
  }, [_c('div', {
    staticClass: "contract-info"
  }, [_vm._m(0), _vm._v(" "), (_vm.defaultBd.name) ? _c('div', {
    staticClass: "item"
  }, [_c('h3', {
    staticClass: "footer-item-title"
  }, [_vm._v("联系BD：" + _vm._s(_vm.defaultBd.name))]), _vm._v(" "), _c('span', {
    staticClass: "footer-item-content"
  }, [_vm._v(_vm._s(_vm.defaultBd.phone))]), _vm._v(" "), _c('a', {
    staticClass: "other-bds",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.moreBds($event)
      }
    }
  }, [_vm._v("联系其他BD\n        "), _c('Icon', {
    attrs: {
      "type": "turbo-ui-arrow-right"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.bdModal),
      callback: function($$v) {
        _vm.bdModal = $$v
      },
      expression: "bdModal"
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("\n        联系BD\n      ")]), _vm._v(" "), _c('ul', _vm._l((_vm.bds), function(bd) {
    return _c('li', {
      key: bd.phone,
      staticClass: "bd-info-item"
    }, [_c('span', {
      staticClass: "bd-info-name"
    }, [_vm._v("姓名：" + _vm._s(bd.name))]), _vm._v(" "), _c('span', {
      staticClass: "bd-info-phone"
    }, [_vm._v("联系电话：" + _vm._s(bd.phone))]), _vm._v(" "), _c('span', {
      staticClass: "bd-info-email"
    }, [_vm._v("联系邮箱：\n            "), _c('a', {
      attrs: {
        "href": 'mailto:' + bd.email
      }
    }, [_vm._v(_vm._s(bd.email))])])])
  })), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeBdModal
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('h3', {
    staticClass: "footer-item-title"
  }, [_vm._v("联系美团 & 电话验证")]), _vm._v(" "), _c('span', {
    staticClass: "footer-item-content"
  }, [_vm._v("400-660-1065")]), _vm._v(" "), _c('span', {
    staticClass: "extra"
  }, [_vm._v("周一到周日 09:00-21:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('h3', {
    staticClass: "footer-item-title"
  }, [_vm._v("反馈 & 投诉")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-content mail",
    attrs: {
      "href": "mailto:lianzheng@meituan.com"
    }
  }, [_vm._v("lianzheng@meituan.com")]), _vm._v(" "), _c('span', {
    staticClass: "extra"
  }, [_vm._v("周一到周日 09:00-21:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item qr-code-wrapper"
  }, [_c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    staticClass: "qr-code",
    attrs: {
      "src": "//p0.meituan.net/codeman/3cb78560876cc53cb80c37d0229fe90c6357.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-item-content"
  }, [_c('h2', [_vm._v("美团旅行商家App")]), _vm._v(" "), _c('span', [_vm._v("扫描二维码下载")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "//www.meituan.com/",
      "target": "_blank"
    }
  }, [_vm._v("©美团网团购meituan.com")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.miitbeian.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("京ICP证070791号京ICP备10211739号 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b75aace","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Footer.vue
// module id = 753
// module chunks = 0